import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import useSegmentation from '@interlayer/js/app/hooks/useSegmentation';
import { TAppConfigTag } from '@interlayer/js/components/system/TagManager/buzz/types';
import { removeActiveTagConfig, setActiveTagConfig } from '@interlayer/js/components/system/App/store/buzz/actions';

export const useActiveTagConfig = ({ config, tagName, tagTypeId, conditions }: TAppConfigTag) => {
    const dispatch = useDispatch();
    const segmentation = useSegmentation();
    const isActive = useMemo(() => {
        return segmentation({ tagName: config.segmentationTag });
    }, [config.segmentationTag, segmentation]);

    useEffect(() => {
        if (isActive) {
            dispatch(setActiveTagConfig({ tagTypeId, config, tagName, conditions } as TAppConfigTag));
        } else {
            dispatch(removeActiveTagConfig({ tagTypeId, tagName }));
        }

        return () => {
            dispatch(removeActiveTagConfig({ tagTypeId, tagName }));
        };
    }, [config, dispatch, isActive, tagName, tagTypeId, conditions]);
};
